var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-content" },
      [
        _c("p", [
          _vm._v("Elija la nueva ubicacion del documento "),
          _c("span", { staticClass: "is-size-6 has-text-info" }, [
            _c("i", { staticClass: "fas", class: _vm.getIcon }),
            _vm._v(" " + _vm._s(_vm.file.nombre)),
          ]),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("explorer", {
          ref: "listado",
          attrs: {
            initFolder: _vm.file.origen_id || _vm.slugRoot,
            slug: _vm.slugRoot,
            rutas: _vm.rutas,
            selected: _vm.selected,
          },
          on: {
            "update:rutas": function ($event) {
              _vm.rutas = $event
            },
            "update:selected": function ($event) {
              _vm.selected = $event
            },
          },
        }),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", { staticClass: "has-text-left" }, [
          _c("b", [_vm._v("Nueva ubicación:")]),
          _vm._v("    " + _vm._s((_vm.selected && _vm.selected.ruta) || "/")),
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        this.file && this.selected && this.file.id == this.selected.id
          ? _c("div", { staticClass: "notification is-warning is-size-7" }, [
              _c("i", { staticClass: "fas fa-exclamation-triangle" }),
              _vm._v(
                " Esta intentando mover una carpeta a si misma. Elija otra ubicación para mover la carpeta\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        this.file && this.selected && this.file.origen_id == this.selected.id
          ? _c("div", { staticClass: "notification is-warning is-size-7" }, [
              _c("i", { staticClass: "fas fa-exclamation-triangle" }),
              _vm._v(" La carpeta ya se encuentra en esta ubicacion\n    "),
            ])
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("footer", { staticClass: "card-footer" }, [
      _c(
        "a",
        {
          staticClass: "card-footer-item",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      !_vm.moverDisabled
        ? _c(
            "a",
            {
              staticClass: "card-footer-item has-text-weight-bold is-uppercase",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.moverDocumento.apply(null, arguments)
                },
              },
            },
            [_vm._v("Mover")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "card-header" }, [
      _c("p", { staticClass: "card-header-title" }, [
        _vm._v("Mover documento"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }